import { Flex, Row, Typography } from 'antd'
import React, { useContext } from 'react'
import { AppContext } from '../../../hooks/AppContext'

type Props = {}

const { Text } = Typography

const fontMobileStyle = {
  fontSize: 12
}

const DescriptionHeader = (props: Props) => {
  const { setMenuSelected, isMobile } = useContext(AppContext)

  return (
    <Row className='bg-[#5AAAFF] min-h-9 items-center mt-10 text-center w-full'>
      <Flex className='flex-[1]' style={{ alignItems: 'center', justifyContent: 'flex-start', marginRight: 16 }}>
        <Text strong className=' text-white' style={isMobile ? fontMobileStyle : { paddingLeft: 12 }}>
        	アカウント
        </Text>
      </Flex>
      <Flex className='flex-[0.5]' style={{ alignItems: 'center', justifyContent: 'flex-start', marginRight: 16 }}>
        <Text strong className=' text-white' style={isMobile ? fontMobileStyle : undefined}>
					商品画像
        </Text>
      </Flex>
      <Flex className='flex-[1]' style={{ alignItems: 'center', justifyContent: 'flex-start', marginRight: 16 }}>
        <Text strong className=' text-white' style={isMobile ? fontMobileStyle : undefined}>
					生成日時
        </Text>
      </Flex>
      <Flex className='flex-[1]' style={{ alignItems: 'center', justifyContent: 'flex-start', marginRight: 16 }}>
        <Text strong className=' text-white' style={isMobile ? fontMobileStyle : undefined}>
					テンプレート名
        </Text>
      </Flex>
      <Flex className='flex-[1]' style={{ alignItems: 'center', justifyContent: 'flex-start', marginRight: 16 }}>
        <Text strong className=' text-white ' style={isMobile ? fontMobileStyle : undefined}>
					商品説明文
        </Text>
      </Flex>
      <Flex className='flex-[1]' style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
        <Text strong className=' text-white' style={isMobile ? fontMobileStyle : undefined}>
        </Text>
      </Flex>
    </Row>
  )
}

export default DescriptionHeader
